import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu';
import * as XLSX from "xlsx";

import AttachmentIcon from '@mui/icons-material/AttachFile';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import BackupIcon from '@mui/icons-material/Backup';
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import { Button } from '@mui/material';
import { URL_CTRL_TRASP, URL_SRV_RAIZ } from '../../router/Url';
import CancelIcon from '@mui/icons-material/Cancel';

import { Phone } from '../../component/Phone.comp';
import { ChangeAddrreess } from './ChangeAddrreess.page';
import { ChangeAddrreesscomp } from './ChangeAddrreesscomp.page';
import { useNavigate } from 'react-router-dom';
import { Component_noDress } from './Component_noDress';
import LoginContext from '../../context/login_context/LoginContext';
import dayjs from 'dayjs'
import { CallTheRealTime } from '../../api/CallTheRealTime.api';
import LoaderData from '../../component/LoaderData';
import { read } from 'xlsx';

var weekOfYear = require('dayjs/plugin/weekOfYear')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone')
dayjs.extend(weekOfYear)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs().tz('America/Santiago')
let formater = new Intl.DateTimeFormat('es-CL', {timeZone: 'America/Santiago'})
let notNow = new Date()
// notNow.setDate(notNow.getDate()+7)
let date_static = notNow.setHours(18,0,0,0);
let date_static_friday = notNow.setHours(13,0,0,0);
let date_static_online = notNow.setHours(8,0,0,0);

let formatFecha = formater.format(date_static)

const FormatTime = async (ttime) => {
  let hr_ = ''
  if(ttime === undefined || ttime === null){
    hr_ = null
    return hr_
  }
  if(typeof ttime === 'number'){
    var resultado = ((ttime* 86400)-2209161600)*1000;
    var fecha = new Date(resultado);
    let the_hour =  fecha.getUTCHours()+":"+fecha.getUTCMinutes();
    
    let a = ''
    let b = ''
    let d = ''
    
    let c = the_hour.split(':')
    c[0].length === 2 ? a = c[0] : a = '0'+c[0]
    c[1].length === 2 ? b = c[1] : b = '0'+String(c[1])
    d = a+":"+b
    hr_ = d
  }else{
    hr_ = ttime
  }
  return hr_
}

function dateExcelToJs(fecha_) {
  // console.log("======>>>>>",fecha_);
  var resultado = ((fecha_* 86400)-2209161600)*1000;
  var fecha = new Date(resultado).toISOString()//1600128000000
    //console.log(fecha);
  return fecha;
}

const format_file_ext = async (lineas) => {
  let headers_arr = Object.keys(lineas[0])
  // console.log(lineas)
  let all_the_lines = []

  for (let hrd = 1; hrd < lineas.length; hrd++) {
    const hrd_ = lineas[hrd];
    // console.log(hrd_.rut)
    for (let dds = 0; dds < headers_arr.length; dds++) {
      const dds_ = headers_arr[dds];
      let turno = await FormatTime(hrd_[dds_])
      if(turno !== null){
        // console.log({
        //   rut:hrd_.rut,
        //   fecha: dateExcelToJs(lineas[0][dds_]).split('T')[0],
        //   year: dateExcelToJs(lineas[0][dds_]).split('T')[0].split('-')[0],
        //   turno: turno,
        // })
        all_the_lines.push({
          nombre: hrd_.nombre,
          rut:hrd_.rut,
          turno: turno,
          fecha: dateExcelToJs(lineas[0][dds_]).split('T')[0],
          year: dateExcelToJs(lineas[0][dds_]).split('T')[0].split('-')[0],
        })
      }
    }
  }

  return all_the_lines
}

const getDuplicatesByRutFecha = async (data) => {
  const counter = {};

  data.forEach(item => {
    const key = `${item.rut}|${item.fecha}`;
    counter[key] = (counter[key] || 0) + 1;
  });

  return data.filter(item => {
    const key = `${item.rut}|${item.fecha}`;
    return counter[key] > 1;
  });
};

const getGroupedDuplicates = async (data) => {
  const map = {};

  data.forEach(item => {
    const key = `${item.nombre}|${item.rut}|${item.fecha}`//|${item.turno}`;
    if (!map[key]) map[key] = [];
    map[key].push(item);
  });

  return Object.values(map).filter(group => group.length > 1);
};

export const CargaMasiva = () => {//init component

  const [IsLoadding, setIsLoadding] = useState(false);//MUESTRA U OCULTA EL MODULO DE CARGA DE DATOS

  const {LoginState,SetLogin,CloseLogin,GetLoginSession} = useContext(LoginContext);
  // console.log(LoginState.mail)
  const navigate = useNavigate();

  const [File_, setFile_] = useState('');
  const [Archivo, setArchivo] = useState('')
  const [Charging, setCharging] = useState(false)
  const [semana, setN_Week] = useState({
    desde: '',
    hasta: ''
  });

  const [fecha, setFecha] = useState('');
  const [duplicados, setDuplicados] = useState([]);
  const [Dupli_NoAuth, setDupli_NoAuth] = useState([]);
  const [No_phone, setNo_phone] = useState([]);
  const [Agregados_list, setAgregados_list] = useState([]);
  const [Nodress, setNodress] = useState([]);
  const [isCompleteForm, setisCompleteForm] = useState(true);
  const [IsHiddedn, setIsHiddedn] = useState(true);
  const [activate, setActivate] = useState(false);
  const [IsActiveBanner, setIsActiveBanner] = useState(true);
  const [shoHidCarga, setshoHidCarga] = useState(true);

  const [duplicados_, setDuplicados_] = useState([]);
  const [duplicados_agrupados, setDuplicados_agrupados] = useState([]);

  const [progreso, setProgreso] = useState(0)


  const HandlePreloadFile = async (e) => {
    setArchivo(e.target.files[0]);
    setFile_(e.target.value.split('\\').pop());
    // console.log(e.target.files[0])
  }

  const HandleUploadFile = async () => {
    setIsLoadding(true);//carga el loader
    setisCompleteForm(true)
    setDuplicados([]);
    setNodress([]);
    setNo_phone([]);
    setAgregados_list([]);
    setDupli_NoAuth([]);

    await setCharging(true)
    const formData = new FormData();
    formData.append('ARCHIVO',Archivo);
    formData.append('FECHA',fecha);
    formData.append('USER',LoginState.user);
    formData.append('MAIL',LoginState.mail);
    const fetc = await fetch(URL_CTRL_TRASP+'uploadmasiveass', {
      method: 'POST',
      headers: {
        'authorization': "marcuxo"
      },
      body: formData
    })
    let duplicidad = ''

    const { processId } = await fetc.json();
      // console.log('Proceso iniciado con ID:', processId);

      const es = new EventSource(`${URL_CTRL_TRASP}progreso/${processId}`);

      es.onmessage = (event) => {
        const recuest = JSON.parse(event.data);
        // console.log('Progreso recibido:', recuest);
        setProgreso(recuest.progreso);

        setTimeout(() => {
          if (recuest.done) {
  console.log('Progreso recibido:', recuest);
            let no_dress_arr = []
            recuest.body.nodress.forEach(ind => {
              ind['state'] = true
              no_dress_arr.push(ind)
            });
            console.log(recuest.body)
            //guarda los datos en variables locales y de entorno
            setDupli_NoAuth(recuest.body.dupli_noAuth);
            setDuplicados(recuest.body.duplicados);
            setAgregados_list(recuest.body.agregados_list);
            setNodress(no_dress_arr);
            setNo_phone(recuest.body.no_phone);
  
            sessionStorage.setItem('duplicado',JSON.stringify(recuest.body.duplicados))
            sessionStorage.setItem('noDress',JSON.stringify(no_dress_arr))
            sessionStorage.setItem('noPhone',JSON.stringify(recuest.body.no_phone))
            sessionStorage.setItem('agregadosList',JSON.stringify(recuest.body.agregados_list))
            sessionStorage.setItem('Dupli_NoAuth',JSON.stringify(recuest.body.dupli_noAuth))
  
            recuest.body.duplicados.forEach(elmt => {
              duplicidad += ".- "+elmt.rut+" "+elmt.turno+"\r"
            });
            if(recuest.done){
              // console.log(recuest.body.duplicados.length)
              let comentario = ''
              if(recuest.body.agregados > 0)comentario += `Se Agregaron ${recuest.body.agregados} solicitudes de transporte\r`
              if(recuest.body.duplicados.length > 0)comentario += `Se encontraron ${recuest.body.duplicados.length} con Transporte cargado\r`
              if(recuest.body.nodress.length > 0)comentario += `Se encontraron ${recuest.body.nodress.length} sin dirección asigada para Transporte\r`
              if(recuest.body.no_phone.length > 0)comentario += `Se encontraron ${recuest.body.no_phone.length} sin numero de Telefono inscrito\r`
              if(recuest.body.dupli_noAuth.length > 0)comentario += `Se encontraron ${recuest.body.dupli_noAuth.length} Solicitudes ya cargadas que NO se modificaron\r`
              setCharging(false)
              alert(comentario)
              setFile_('')
              setArchivo('')
              document.getElementById('file').value = ''
              // document.location.reload()
              setIsLoadding(false);//oculta el loader
            }else{
              alert('Error al cargar los datos por favor inténtelo nuevamente.')
            }
  
            es.close();
          }
        }, 1000);
      };

  }

  // compara las fechaspara habiliatar o bloquear la plataforma
  async function CompareDateAndTime(fecha){
    
    let realTime = await CallTheRealTime()
    
    let DayLimit = '';
    let DayAntes = '';
    let a = new Date(fecha);
    let b = new Date(date_static);
    let c = new Date(date_static_friday);
    let wakeup = new Date(date_static_online);
    let hrsServ = realTime.hora
    // console.log(hrsServ,b.getHours())
    // console.log('num dia',dayjs().day(0)['$d'])
    // console.log(a.getHours(),b.getHours(),c.getHours())
    // console.log("================>",dayjs().isSame(dayjs().day(0), 'day'));
    if(dayjs().isSame(dayjs().day(0), 'day')){
      setIsHiddedn(false)
    }else{
      if(LoginState.area === "SSGG"){
        // console.log('SSGG')
        DayLimit = dayjs().day(0)
        DayAntes = dayjs().day(6)

        let antes = dayjs().isBefore(dayjs(DayLimit)['$d'])
        let isSame = dayjs().isSame(DayAntes, 'day')

        if(antes){
          if(isSame){
            if(hrsServ < b.getHours() && hrsServ >= wakeup.getHours()){
              // setIsHiddedn(true)//------------not bloked to SSGG
              // console.log('a')
            }else{
              setIsHiddedn(false)
              // console.log('b')
            }
          }else{
            // setIsHiddedn(true)//------------not bloked to SSGG
            // console.log('c')
          }
        }else{
            // setIsHiddedn(true)//------------not bloked to SSGG
            // console.log('e')
        }
      }else{
        DayLimit = dayjs().day(6)
        DayAntes = dayjs().day(5)

        let antes = dayjs().isBefore(dayjs(DayLimit)['$d'])
        let isSame = dayjs().isSame(DayAntes, 'day')

        if(antes){
          if(isSame){
            if(hrsServ < c.getHours() && hrsServ >= wakeup.getHours()){
              setIsHiddedn(true)
              // console.log('f')
            }else{
              setIsHiddedn(false)
              // console.log('g')
            }
          }else{
            if(hrsServ < b.getHours() && hrsServ >= wakeup.getHours()){
              setIsHiddedn(true)
              // console.log('h')
            }else{
              setIsHiddedn(false)
              // console.log('i')
            }
          }
        }else{
            setIsHiddedn(false)
            // console.log('j')
        }
      }
    }
  }

  const Obtain_File_Example = async () => {
    let url = 'files/Template_Transporte.xlsx';
      let a = document.createElement("a");
      a.href = url;//to web add url_server+build/
      // a.href = url;
      a.download = "Template_transporte.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
  }

  const CloseBanner = async () => {
    sessionStorage.setItem('banner', false)
    setIsActiveBanner(false)
  }
  

  useEffect(() => {
    let notNow = new Date()
    let now_ = notNow.setHours(15,0,0,0)
    let desde = ''
    if(new Date().toLocaleString()<new Date(now_).toLocaleString()){
      desde = new Date().toISOString().split('T',1)[0]
    }else{
      let nexday = notNow.setDate(notNow.getDate()+1)

      desde = notNow.toISOString().split('T')[0]
    }
    setN_Week(
      // {
      //   "week": dayjs(dayjs(dayjs().day(1).$d).subtract(1, 'week').$d).week(),
      //   "fecha": new Date(dayjs(dayjs().day(1).$d).subtract(1, 'week').$d).toISOString().split('T',1)[0]
      // },
      {
        // "wee": dayjs(dayjs().day(1).$d).week(),
        "desde": desde,
        // "desde": new Date(dayjs(dayjs().day(1).$d).$d).toISOString().split('T',1)[0],
        "hasta": new Date(dayjs(dayjs().day(7).$d).$d).toISOString().split('T',1)[0]
      },
      // {
      //   "week": dayjs(dayjs(dayjs().day(1).$d).add(1, 'week').$d).week(),
      //   "desde": new Date(dayjs(dayjs().day(1).$d).add(1, 'week').$d).toISOString().split('T',1)[0],
      //   "hasta": new Date(dayjs(dayjs().day(7).$d).add(1, 'week').$d).toISOString().split('T',1)[0]
      // }
      // ,{
      //   "week": dayjs(dayjs(dayjs().day(1).$d).add(2, 'week').$d).week(),
      //   "fecha": new Date(dayjs(dayjs().day(1).$d).add(2, 'week').$d).toISOString().split('T',1)[0] 
      // }
    )
  }, [])

  useEffect(() => {
    // console.log(fecha, File_)
    if(File_===''){
      setisCompleteForm(true)
    }else{
      setisCompleteForm(false)
    }
  }, [File_, fecha])
  
  useEffect(() => {
    CompareDateAndTime(Date.now())
    let intervalo = setInterval(() => {
      // console.log('intervalo')
      CompareDateAndTime(Date.now())
    }, 10000);
    // intervalo()
    return () => {
      clearInterval(intervalo)
    } 
  }, [])

  // guarda losdatos en la memoria locar para cambiar de pagina sin perder los datos
  useEffect(() => {
    let duplicados_ = sessionStorage.getItem('duplicado');
    let noDress_ = sessionStorage.getItem('noDress');
    let noCell_ = sessionStorage.getItem('noPhone');
    let agregadosList_ = sessionStorage.getItem('agregadosList');
    let dupli_NoAuth_ = sessionStorage.getItem('Dupli_NoAuth');

    if(duplicados_){
      setDuplicados(JSON.parse(duplicados_))
    }
    if(noDress_){
      setNodress(JSON.parse(noDress_))
    }
    if(noCell_){
      setNo_phone(JSON.parse(noCell_))
    }
    if(agregadosList_){
      setAgregados_list(JSON.parse(agregadosList_))
    }
    if(dupli_NoAuth_){
      setDupli_NoAuth(JSON.parse(dupli_NoAuth_))
    }

    let banner = sessionStorage.getItem('banner')
    // console.log('banner', banner)
    if(banner===null){
      // console.log('null///')
      setIsActiveBanner(true)
      sessionStorage.setItem('banner', true)
    }
    if(banner==='false'){
      // console.log('false///')
      setIsActiveBanner(false)
      sessionStorage.setItem('banner', false)
    }
  }, [])

  useEffect(() => {
    // console.log("Archivo=>", Archivo)
    if(Archivo === '' || Archivo === null || Archivo === undefined) return
    const readExcel = (file) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);
        
        // setExcelData(parsedData);
        // console.log('Datos parseados:', parsedData[1]);

        if (!parsedData[1].hasOwnProperty("nombre")) {
          console.log("NO Existe la key nombre");
          setisCompleteForm(true)
          alert('El formato del archivo no es correcto, por favor descargue y revise el formato del archivo de ejemplo y vuelva a intentarlo.')
        }

        format_file_ext(parsedData).then((res)=>{
          // console.log('Datos formateados:', res);
          getDuplicatesByRutFecha(res).then((duplis)=>{
            // console.log('Duplicados encontrados:', duplis);
            setDuplicados_(duplis)
          })
          getGroupedDuplicates(res).then((groupedDuplis)=>{
            // console.log('Grupos de duplicados encontrados:', groupedDuplis);
            setDuplicados_agrupados(groupedDuplis)
          })
        })
      };
      
      reader.readAsBinaryString(Archivo);
    };
    readExcel(Archivo)
  }, [Archivo])
  return (
    <>
      <HeaderMenu Pag_Sel={'carga_masiva'} />
      <br/>
      <br/>

      {/* modulo carga de carga archivo */}
      {
        IsHiddedn || LoginState.mail === 'murrutiam@ariztia.com'?
        <div className='container mt-2'>
          <div className='row performance-2'>
            
            <div className='col-12 py-2'>
              <h5>Cargar Transporte</h5>
            </div>
            
            <div className='col-12 col-md-12 text-center pt-3 '>
              <div className='col-12'>
                <label htmlFor='file' id="secondfile" className={Charging?'btn btn-sm btn-info disabled':'btn btn-sm btn-info'}>{
                  File_===''? 
                  <>Seleccionar archivo <AttachmentIcon /></>
                  :<><Inventory2OutlinedIcon /> {File_}</>
                }</label>
                <input
                  type="file"
                  name="file"
                  id="file"
                  disabled={Charging}
                  className="form-control"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  required
                  onChange={(e)=>HandlePreloadFile(e)}
                />
              </div>
            </div>
            {/* <div className='col-12 col-md-6 text-center pt-3'>
              <div className="form-group">
                <div className='input-group date' id='datetimepicker1'>
                  <input type='date' value={fecha} onChange={(e)=>setFecha(e.target.value)} className="form-control" name='fecha_to_load' min={semana.desde} max={semana.max} />
                  
                </div>
            </div>
            </div> */}
            <div className='col-12 text-center pt-3'>
              <Button
                variant='contained'
                disabled={isCompleteForm || duplicados_agrupados.length > 0}
                onClick={()=>HandleUploadFile()}
              >
                {
                  Charging?'Cargando archivo . . . ..':'Cargar Archivo' 
                }<FilePresentOutlinedIcon />
                  
              </Button>
            </div>
            <div className='col-12 text-right'>
              <a className='badge badge-pill badge-warning p-2' download={'Template_Transporte'} href='/file/Template_Transporte_name_new.xlsx'>Descargar archivo ejemplo</a>
              {/* <p onClick={()=>Obtain_File_Example()} style={{cursor:'pointer'}}>Descargar ejemplo</p> */}
            </div>

            <div className='col-12 text-center'>
              <small className='text-danger'>Solo es posible cargar los transportes de lunes a jueves desde <b>07:00hrs</b> hasta las <b>16:00hrs</b></small><br/>
              <small className='text-danger'>y los Viernes desde <b>07:00hrs</b> hasta las <b>12:00hrs</b>.</small><br/>
              <small className='text-danger'>Tome en <b>consideración</b> estos horarios para <b>coordinar</b> los <b>transportes con tiempo</b>.</small>
            </div>
          </div>
        </div>
        :
        <div className='col-12 text-center'>
          <p className='lead'>La carga de solicitudes de transporte es:</p>
          <p className='lead'>De lunes a jueves de <span className='text-danger'><b>07:00hrs</b></span> hasta las <span className='text-danger'><b>16:00hrs</b></span></p>
          <p className='lead'>Los viernes de <span className='text-danger'><b>07:00hrs</b></span> hasta las <span className='text-danger'><b>12:00hrs</b></span></p>
        </div>
      }

      {/* precarga de datos, muestra los datos duplicados */}
      {
        duplicados_.length > 0 && <div className='container my-3' style={{borderLeft: '5px solid #fd0000', backgroundColor: '#fe8383', boxShadow: '3px 3px 5px #0101017c'}}>
          <div className='row'>
            <div className='col-12 text-center'>
              <small className='text-white'><b>Su archivo de carga tiene datos duplicados, verifíquelos para corregirlos antes de continuar.</b></small><br />
              <small className='text-white'><b>De lo contrario no podrá continuar con la carga.</b></small>
            </div>
            <div className='col'>
              <table className="table table-sm table-striped table table-bordered table-hover bg-white">
                  <thead className="thead-dark">
                  <tr>
                    <th>RUT</th>
                    <th>Nombre</th>
                    <th>Fecha</th>
                    <th>Turno</th>
                    <th>Año</th>
                    <th className='text-center'>Repeticiones</th>
                  </tr>
                </thead>
                <tbody>
                  {duplicados_agrupados.map((group, index) => {
                    const { rut, nombre, fecha, turno, year } = group[0];

                    return (
                      <tr key={index}>
                        <td>{rut}</td>
                        <td>{nombre}</td>
                        <td>{fecha}</td>
                        <td>{turno}</td>
                        <td>{year}</td>
                        <td className='text-center'>{group.length}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      {/* lista los datos ingresados y cargados a la base de datos */}
      {
        Agregados_list.length &&
        <div className='container my-3'>
          <div className='row'>
            <div className='col-12'>
              <span className='float-right'>
                <button
                  className='btn btn-sm btn-warning'
                  onClick={()=>setshoHidCarga(!shoHidCarga)}
                >
                  {shoHidCarga?'Ocultar':'Mostrar'}
                </button>
                
              </span>
              <h5>Solicitudes de transporte Cargadas</h5>
            </div>
            <div className={shoHidCarga?'col':'col ocultacion'}>
              <table className="table table-sm table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>Rut</th>
                    <th>Nombre</th>
                    <th>Turno</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Agregados_list.map((imt, index) =>
                    <tr key={index}>
                      <td><small>{imt.rut}</small></td>
                      <td><small>{imt.nombre}</small></td>
                      <td><small>{imt.turno}</small></td>
                      <td><small>{imt.fecha}</small></td>
                    </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      {/* lista de los usuarios sin direccion asignada */}
      {
        Nodress.length &&
        <div className='container my-3'>
          <div className='row'>
            <div className='col-12'>
              <h5>Usuario sin Dirección asignada</h5>
            </div>
            <div className='col'>
              <table className="table table-sm table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>Rut</th>
                    <th>Nombre</th>
                    <th>Turno</th>
                    <th>Fecha</th>
                    <th>Accion</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Nodress.map((imt, index) =>
                      <Component_noDress imt={imt} key={index} />
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      {/* lista de usuarios que no tienen numero de telefono asignado */}
      {
        No_phone.length &&
        <div className='container my-3'>
          <div className='row'>
            <div className='col-12'>
              <h5>Usuarios sin Numero de Telefono</h5>
            </div>
            <div className='col'>
              <table className="table table-sm table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>Rut</th>
                    <th>Nombre</th>
                    <th>Telefono</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    No_phone.map((imt) =>
                      <Phone Datos={imt} key={imt._id}/>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
      
      {/* lista de usuarios con el turno ya cargado */}
      {
        duplicados.length &&
        <div className='container my-3'>
          <div className='row'>
            <div className='col-12'>
              <h5>Usuarios con trasporte cargado y modificado</h5>
            </div>
            <div className='col'>
              <table className="table table-sm table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>Rut</th>
                    <th>Nombre</th>
                    <th>Turno</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    duplicados.map((imt, index) =>
                      <tr key={index}>
                        <td><small>{imt.rut}</small></td>
                        <td><small>{imt.nombre}</small></td>
                        <td><small>{imt.turno}</small></td>
                        <td><small>{imt.fecha}</small></td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      {/* lista de usuarios con el turno ya cargado */}
      {
        Dupli_NoAuth.length &&
        <div className='container my-3'>
          <div className='row'>
            <div className='col-12'>
              <h5>Usuarios con trasporte ya cargado y <span className='text-danger'>No</span> Modificado</h5>
              <small className='text-danger'><b>Las siguientes solicitudes están bloqueadas para cambios, solo un administrador autorizado puede realizar los cambios.</b></small>
            </div>
            <div className='col'>
              <table className="table table-sm table table-bordered table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th>Rut</th>
                    <th>Nombre</th>
                    <th>Turno</th>
                    <th>Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Dupli_NoAuth.map((imt, index) =>
                      <tr key={index}>
                        <td><small>{imt.rut}</small></td>
                        <td><small>{imt.nombre}</small></td>
                        <td><small>{imt.turno}</small></td>
                        <td><small>{imt.fecha}</small></td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }

      {
        IsLoadding &&  <LoaderData />
      }

      {
        IsLoadding && <div className="" style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh', zIndex: 9999}}>
        <div className="col-12 p-0 m-0">
          <div className="progress" style={{height: '30px'}}>
              <div
                  className="progress-bar progress-bar-striped bg-success progress-bar-animated"
                  role="progressbar"
                  style={{width: `${progreso}%`}}
                  aria-valuenow={progreso}
                  aria-valuemin="0"
                  aria-valuemax="100"
              >
                  {progreso}%
              </div>
          </div>
        </div>
        </div>
      }
      
        
      {
        IsActiveBanner && <div className='' style={{width:'100%', height:'100vh', position:'fixed', top:0, left:0, backgroundColor: '#0000007a', zIndex: 9999, backdropFilter: 'blur(5px)'}}>
          <div className='row d-flex justify-content-center align-items-center' style={{width:'100%', height:'100%'}}>
            <div className='col-6 p-5' style={{backgroundColor: '#fff3cd', borderLeft: '5px solid #f9d25f'}}>
              <h5 className='text-center'><b>¡Atención!</b></h5>
              <p className='text-center'><b>El archivo para la carga de solicitudes de transporte ha sido actualizado.</b> Antes de realizar la carga, <b>revise el formato del archivo de ejemplo</b> para asegurarse de que cumpla con la estructura requerida y así <b>evitar errores en el proceso de carga de datos.</b></p>
              <span className='float-right'>
                <button
                  className='btn btn-sm btn-warning'
                  onClick={()=>CloseBanner()}
                >
                  Cerrar
                </button>
              </span>
            </div>
          </div>
        </div>
      }
      
    </>
  )
}
